import React from "react";
import data from '../data'
import Project from "./Project";


const Projects = () => {
  return (
    <div className="" id="projects">
      <div id="bg-div" className="relative">
        {" "}
        <div className="h-64 w-screen bg-[rgb(52 52 189 / 79%)]"></div>
      </div>
      <h1 className="text-center text-5xl h-20 ">Projects</h1>
        <ul>
          {data.map(project=>(
           <Project data={project}/>
          ))}
        </ul>
      <hr className="block mx-auto h-1 bg-slate-800 w-3/4 my-3" />
    </div>
  );
};

export default Projects;
